import {
  Button,
  InputAdornment,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import React from "react"
import TextField from "@mui/material/TextField"
import {
  useGetDropoutRateQuery,
  useUpdateDropoutRateMutation,
} from "../../api/DropoutRateApi"
import { SubmitHandler, useFieldArray, useForm } from "react-hook-form"
import { IDropoutRateInput } from "../../model/create/DropoutRateInput"
import { keycloakInstance } from "../../../../shared/libs/keycloack/config"

const DropoutRate = ({ edit, setEdit }: { edit: boolean; setEdit: any }) => {
  const dropoutRate = useGetDropoutRateQuery()

  if (dropoutRate.error) {
    return <Typography>{JSON.stringify(dropoutRate.error)}</Typography>
  }

  if (dropoutRate.isLoading) {
    return <LinearProgress />
  }

  return (
    <>
      {dropoutRate.data && (
        <DropoutRateBody
          data={dropoutRate.data}
          edit={edit}
          setEdit={setEdit}
        />
      )}
    </>
  )
}

const DropoutRateBody = ({
  data,
  edit,
  setEdit,
}: {
  data: IDropoutRateInput[]
  edit: boolean
  setEdit: any
}) => {
  const { handleSubmit, register, control } = useForm<any>({
    defaultValues: {
      smkt: data.filter((item) => item.project === "Самокат"),
      mm: data.filter((item) => item.project === "Мегамаркет"),
    },
  })

  // const onSubmit: SubmitHandler<IDropoutRateInput> = (data: any) =>
  //   console.log(...data.smkt, ...data.mm)

  const { fields } = useFieldArray({
    control,
    name: "smkt",
  })
  const { fields: mmFields } = useFieldArray({
    control,
    name: "mm",
  })

  const [updateDropoutRate] = useUpdateDropoutRateMutation()

  const onSubmit: SubmitHandler<IDropoutRateInput> = async (data: any) => {
    try {
      if (edit) return
      const dataArray = [...data.smkt, ...data.mm]

      const response = await updateDropoutRate(dataArray)

      console.log(response)
    } catch (error) {
      console.error("Error adding interview:", error)
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={"space-between"}
        spacing={"20px"}
      >
        <Typography sx={{ fontSize: "20", fontWeight: "700" }}>
          Процент отсева
        </Typography>
        <Typography
          sx={{
            fontSize: "16",
            fontWeight: "bold",
            color: "rgba(139, 139, 139, 1)",
          }}
        >
          {edit ? "Режим внесения изменений" : ""}
        </Typography>

        {keycloakInstance.realmAccess?.roles.some((role) =>
          ["hiring-admin"].includes(role),
        ) && (
          <Button
            type="submit"
            onClick={() => setEdit(!edit)}
            startIcon={!edit ? <EditIcon /> : <CheckCircleOutlineIcon />}
          >
            {!edit ? "Внести изменения" : "Сохранить"}
          </Button>
        )}
      </Stack>
      <Stack
        direction={"row"}
        sx={{
          bgcolor: "background.paper",
          height: "69.7vh",
          mt: "30px",
          gap: "40px",
          mb: "14px",
          mx: "30px",
        }}
      >
        <Stack
          sx={{
            bgcolor: "rgba(105, 51, 176, 1)",
            width: "50%",
            height: "591px",
            borderRadius: "30px",
            p: "30px",
          }}
          spacing={"10px"}
          alignItems={"center"}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              textTransform: "uppercase",
              color: "#F2F2F2",
              pb: "30px",
            }}
          >
            Мегамаркет
          </Typography>
          {mmFields.map((item, index) => (
            <Stack
              key={item.id}
              direction={"row"}
              sx={{ width: "100%" }}
              spacing={"20px"}
              justifyContent={"space-between"}
            >
              <TextField
                disabled
                fullWidth
                sx={{
                  bgcolor: "rgba(242, 242, 242, 1)",
                  borderRadius: "10px",
                  "& fieldset": { border: "none" },
                }}
                inputProps={register(`mm.${index}.name`)}
              />
              <TextField
                disabled={!edit}
                inputProps={{
                  ...register(`mm.${index}.dropoutRate`, {
                    valueAsNumber: true,
                  }),
                }}
                type="number"
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          color: edit ? "" : "rgba(0, 0, 0, 0.38)",
                        }}
                      >
                        %
                      </span>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  bgcolor: "rgba(242, 242, 242, 1)",
                  borderRadius: "10px",
                  width: "100px", // Увеличьте или уменьшите ширину поля по необходимости
                  "& fieldset": {
                    border: "none",
                  },
                  "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                    {
                      "-webkit-appearance": "none",
                      margin: 0,
                    },
                }}
              />
            </Stack>
          ))}
        </Stack>
        <Stack
          sx={{
            bgcolor: "rgba(255, 51, 95, 1)",
            width: "50%",
            height: "591px",
            borderRadius: "30px",
            p: "30px",
          }}
          spacing={"10px"}
          alignItems={"center"}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              textTransform: "uppercase",
              color: "#F2F2F2",
              pb: "30px",
            }}
          >
            Самокат
          </Typography>
          {fields.map((item, index) => (
            <Stack
              key={item.id}
              direction={"row"}
              sx={{ width: "100%" }}
              spacing={"20px"}
              justifyContent={"space-between"}
            >
              <TextField
                disabled
                fullWidth
                sx={{
                  bgcolor: "rgba(242, 242, 242, 1)",
                  borderRadius: "10px",
                  "& fieldset": { border: "none" },
                }}
                inputProps={register(`smkt.${index}.name`)}
              />
              <TextField
                disabled={!edit}
                inputProps={{
                  ...register(`smkt.${index}.dropoutRate`, {
                    valueAsNumber: true,
                  }),
                }}
                type="number"
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span
                        style={{
                          color: edit ? "" : "rgba(0, 0, 0, 0.38)",
                        }}
                      >
                        %
                      </span>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  bgcolor: "rgba(242, 242, 242, 1)",
                  borderRadius: "10px",
                  width: "100px", // Увеличьте или уменьшите ширину поля по необходимости
                  "& fieldset": {
                    border: "none",
                  },
                  "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                    {
                      "-webkit-appearance": "none",
                      margin: 0,
                    },
                }}
              />
            </Stack>
          ))}
        </Stack>
      </Stack>
    </form>
  )
}

export default DropoutRate
